'use strict';

module.exports = Object.freeze({
	'TMP_VALID_EXTS': '.gif,.png,.jpeg,.jpg,.doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.txt,.zip',
	'TMP_FILES': 1,
	'TMP_FILE_SIZE': 3 * 1024 * 1024,
	'INVALID_WORDS': ['\\', '/', ':', '*', '?', '"', '<', '>', '|', '#', '%', '&'],
});